module.exports = __webpack_public_path__ + "img/refuse.3d58b29c.svg";